import classNames from "classnames/bind";
import type { ResolvedArticleCard } from "resolvers/data/articleCardResolver";
import ArticleCard from "./ArticleCard";
import styles from "./ArticleCardList.module.scss";

const cx = classNames.bind(styles);

export interface ArticleCardListProps {
    posts: ResolvedArticleCard[];
    featuredCardNumber?: number;
    arePinned?: boolean;
    pinnedArticles?: ResolvedArticleCard[];
    pageNumber: number;
    hasSmallerGap?: boolean;
}

const ArticleCardList = (props: ArticleCardListProps) => {
    const { hasSmallerGap } = props;
    const pinnedArticles = props.pinnedArticles || [];

    pinnedArticles.sort(sortArticlesByDates);
    const articles = props.posts;

    articles.sort(sortArticlesByDates);

    return (
        <ol className={cx("list", "articleCardList", { hasSmallerGap })}>
            {!!pinnedArticles.length &&
                (props.pageNumber === 1 || !props.pageNumber) &&
                pinnedArticles.map((post) => (
                    <li className={cx("listItem")} key={post.id}>
                        <ArticleCard {...post} isPinned />
                    </li>
                ))}
            {props.posts.map((post, i) => (
                <li
                    className={cx("listItem", {
                        featured: props.featuredCardNumber
                            ? i === props.featuredCardNumber - 1 &&
                              (props.pageNumber === 1 || !props.pageNumber)
                            : false,
                    })}
                    key={post.id}
                >
                    <ArticleCard
                        {...post}
                        isFeatured={
                            props.featuredCardNumber
                                ? i === props.featuredCardNumber - 1 &&
                                  (props.pageNumber === 1 || !props.pageNumber)
                                : false
                        }
                        isPinned={props.arePinned}
                    />
                </li>
            ))}
        </ol>
    );
};

export default ArticleCardList;

function sortArticlesByDates(a: ResolvedArticleCard, b: ResolvedArticleCard) {
    let compValA;
    let compValB;
    a.dateModified ? (compValA = a.dateModified) : (compValA = a.datePublished);
    b.dateModified ? (compValB = b.dateModified) : (compValB = b.datePublished);
    if (compValB > compValA) return 1;
    if (compValB < compValA) return -1;
    return 0;
}
